import { useQuery } from "@tanstack/react-query"

interface ApiBranch {
  id: string
  name: string
  isVIPBranch?: boolean
  location?: { name?: string } | null
}

interface BranchesResponse {
  totalItems: number
  totalPages: number
  currentPage: number
  data: ApiBranch[]
}

interface BranchItem {
  id: string
  name: string
  subtitle?: string
  badge?: "VIP" | "NEW"
}

async function fetchBranches(): Promise<BranchItem[]> {
  const apiUrl = import.meta.env.VITE_API_URL || import.meta.env.NEXT_PUBLIC_API_URL || ''
  const res = await fetch(`${apiUrl}/v1/branches`, {
    cache: "no-store",
  })

  if (!res.ok) {
    return []
  }

  const json = (await res.json()) as BranchesResponse

  return Array.isArray(json?.data)
    ? json.data.map((b) => ({
        id: String(b.id ?? ""),
        name: String(b.name ?? ""),
        subtitle: b?.location?.name ? String(b.location.name) : "",
        badge: b.isVIPBranch ? ("VIP" as const) : undefined,
      }))
    : []
}

export function useBranches() {
  return useQuery({
    queryKey: ["branches"],
    queryFn: fetchBranches,
  })
}

